(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categories-showcase"] && !Shopify.designMode) return;
  try {
    
  const categoriesShowcaseContainers = document.querySelectorAll('[data-js-target="categories_showcase_container"]');

  categoriesShowcaseContainers.forEach((container) => {
    const tabButtons = container.querySelectorAll('[data-js-target="categories_showcase_tab_button"]');
    const tabContents = document.querySelectorAll('[data-js-target="categories_showcase_tab_content"]');

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const tabId = button.getAttribute('data-tab-id');

        tabButtons.forEach((btn) => {
          btn.classList.toggle('btn_outline', btn !== button);
        });

        tabContents.forEach((tab) => {
          const contentTabId = tab.getAttribute('data-tab-id');

          tab.classList.toggle('hidden', contentTabId !== tabId);
          tab.setAttribute('aria-hidden', contentTabId !== tabId);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const mobileToggleButton = document.querySelector('[data-js-target="mobile_menu_toggle"]');
    const mobileMenu = document.querySelector('[data-js-target="mobile_menu"]');

    const mobileMenuDrawer = document.querySelector('[data-js-drawer="mobile_nav_drawer"]');

    mobileToggleButton.addEventListener('click', () => {
      mobileToggleButton.classList.toggle('active');
    });

    mobileMenuDrawer.addEventListener('drawer:close', () => {
      mobileToggleButton.classList.remove('active');
    });
  });

  function handleHeaderDropdown() {
    const navGroup = document.querySelector('[data-js-target="nav_group"]');

    const dropdownOverlay = document.querySelector('[data-js-target="nav_group_dropdown_overlay"]');

    const toggles = navGroup.querySelectorAll('[data-js-nav-group-dropdown-toggle]');

    toggles.forEach((toggle) => {
      const dropdown = toggle.querySelector('[data-js-nav-group-dropdown');
      const dropdownContent = toggle.querySelector('[data-js-nav-group-dropdown-content]');

      let isMouseOver = false;
      let latestLeaveEvent = null;

      toggle.addEventListener('mouseenter', () => {
        isMouseOver = true;

        toggle.classList.add('active');

        dropdown.classList.add('active');
        dropdown.classList.remove('invisible');

        dropdownOverlay.classList.remove('opacity-0');

        requestAnimationFrame(() => {
          const maxHeight = dropdownContent.scrollHeight; // content + padding
          dropdown.style.setProperty('--dropdown-height', `${maxHeight}px`);

          dropdown.focus();
          document.body.classList.add('dropdown_open');
        });
      });

      function closeDropdown(leavePeriod = 200) {
        isMouseOver = false;
        latestLeaveEvent = new Date();

        let localLatestLeaveEvent = latestLeaveEvent;

        setTimeout(() => {
          if (
            isMouseOver ||
            localLatestLeaveEvent !== latestLeaveEvent // another leave event happened in the meantime
          )
            return;

          requestAnimationFrame(() => {
            dropdown.style.setProperty('--dropdown-height', `0px`);
            dropdown.classList.remove('active');

            // Wait for the transition to end before adding 'invisible'
            dropdown.addEventListener('transitionend', function handler(e) {
              if (e.propertyName !== 'max-height' || dropdown.classList.contains('active')) return;

              dropdown.classList.add('invisible');
              dropdown.removeEventListener('transitionend', handler);
            });

            dropdownOverlay.classList.add('opacity-0');
            toggle.classList.remove('active');

            document.body.classList.remove('dropdown_open');
            toggle.focus();
          });
        }, leavePeriod);
      }

      toggle.addEventListener('mouseleave', () => closeDropdown(), { passive: true });

      toggle.addEventListener('click', (e) => {
        if (e.target !== toggle && dropdown.contains(e.target)) return;

        if (dropdown.classList.contains('active')) {
          closeDropdown(0);
        } else {
          toggle.dispatchEvent(new Event('mouseenter'));
        }
      });

      dropdown.addEventListener('tab:recalculate_height', () => {
        if (!dropdown.classList.contains('active')) return;

        requestAnimationFrame(() => {
          const maxHeight = dropdownContent.scrollHeight; // content + padding
          dropdown.style.setProperty('--dropdown-height', `${maxHeight}px`);
        });
      });
    });
  }

  handleHeaderDropdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const productCarousel = document.querySelector('[data-js-target="product_carousel"]');
  const productImages = productCarousel.querySelectorAll('img[data-image-id]');

  const variantRadios = productCarousel.querySelectorAll('input[data-js-target="variant_radio"]');

  // Handle carousel scroll and button active states
  variantRadios.forEach((input) => {
    input.addEventListener('change', () => {
      const emblaInstance = window.emblaCarouselsMap.get('product_carousel');

      if (!emblaInstance) return;

      const variantImageId = input.dataset.variantImageId;

      let scrolledToVariantImage = false;

      productImages.forEach((img, idx) => {
        const imageId = img.dataset.imageId;

        if (imageId === variantImageId) {
          emblaInstance.scrollTo(idx);
          scrolledToVariantImage = true;
        }
      });

      if (!scrolledToVariantImage) {
        emblaInstance.scrollTo(0);
      }

      const variantRadioLabel = input.nextElementSibling;

      if (!variantRadioLabel) return;

      const shouldBeActive = !variantRadioLabel.classList.contains('btn_outline');

      variantRadioLabel.classList.toggle('btn_outline', shouldBeActive);

      variantRadios.forEach((otherInput) => {
        const btnLabel = otherInput.nextElementSibling;

        if (btnLabel !== variantRadioLabel) {
          btnLabel.classList.add('btn_outline');
        }
      });
    });
  });

  const finalPriceEl = productCarousel.querySelector('[data-js-target="final_price"]');
  const compareAtPriceEl = productCarousel.querySelector('[data-js-target="compare_at_price"]');

  const formatPrice = (price) =>
    (price / 100).toLocaleString('ro-RO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  // Handle price update on variant change
  variantRadios.forEach((input) => {
    input.addEventListener('change', () => {
      const variantId = input.dataset.variantId;

      if (!variantId) return;

      const variantData = window.productData.variants.find((v) => v.id == variantId);

      if (!variantData) return;

      if (variantData.compare_at_price > variantData.price) {
        const compareAtPrice = formatPrice(variantData.compare_at_price);

        compareAtPriceEl.innerHTML = `<s>${compareAtPrice} lei</s>`;
        compareAtPriceEl.style.display = 'inline';
      } else {
        compareAtPriceEl.style.display = 'none';
      }

      const finalPrice = formatPrice(variantData.price);
      finalPriceEl.textContent = finalPrice + ' lei';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  const searchForm = document.querySelector('[data-js-target="search_form"]');
  const searchFormFilterInputs = searchForm.querySelectorAll('[data-js-target="search_form_filter_input"]');
  const searchFormClearFiltersButtons = searchForm.querySelectorAll('[data-js-target="search_form_clear_filters"]');
  const applyFilterChangesButtons = searchForm.querySelectorAll('[data-js-target="search_form_apply_filters"]');

  searchForm.addEventListener('submit', (e) => {
    e.preventDefault();

    searchFormFilterInputs.forEach((input) => {
      if (input.type === 'number' && (input.value === '' || input.value === '0')) {
        input.value = '';
      }
    });

    searchForm.submit();
  });

  searchFormClearFiltersButtons.forEach((searchFormClearFiltersButton) => {
    searchFormClearFiltersButton.addEventListener('click', (e) => {
      searchFormFilterInputs.forEach((input) => {
        if (input.type === 'checkbox') {
          input.checked = false;
        } else {
          input.value = '';
        }
      });

      searchForm.submit();
    });
  });

  searchFormFilterInputs.forEach((input) => {
    input.addEventListener('input', () => {
      applyFilterChangesButtons.forEach((button) => button.classList.remove('hidden'));
    });

    input.addEventListener('changed', () => {
      applyFilterChangesButtons.forEach((button) => button.classList.remove('hidden'));
    });
  });

  const mobileFiltersToggle = searchForm.querySelector('[data-js-target="search_form_mobile_filters_toggle"]');
  const mobileFilters = searchForm.querySelector('[data-js-target="search_form_mobile_filters"]');

  mobileFiltersToggle.addEventListener('click', () => {
    const isOpen = mobileFilters.getAttribute('data-open') === 'true';
    const scrollHeight = mobileFilters.scrollHeight;

    if (isOpen) {
      mobileFilters.style.setProperty('--max-height', `${scrollHeight}px`);

      requestAnimationFrame(() => {
        mobileFilters.style.setProperty('--max-height', '0px');
        mobileFilters.setAttribute('data-open', 'false');
        mobileFiltersToggle.classList.remove('btn_primary');
        mobileFiltersToggle.classList.add('btn_light', 'btn_outline');
        mobileFiltersToggle.setAttribute('aria-expanded', 'false');
      });
    } else {
      mobileFilters.style.setProperty('--max-height', `${scrollHeight}px`);
      mobileFilters.setAttribute('data-open', 'true');
      mobileFiltersToggle.classList.remove('btn_light', 'btn_outline');
      mobileFiltersToggle.classList.add('btn_primary');
      mobileFiltersToggle.setAttribute('aria-expanded', 'true');
    }
  });

  mobileFilters.addEventListener('transitionend', () => {
    const isOpen = mobileFilters.getAttribute('data-open') === 'true';

    if (isOpen) {
      mobileFilters.style.setProperty('--max-height', 'none');
    }
  });

  function adjustFilterInputsBasedOnViewport() {
    searchFormFilterInputs.forEach((input) => {
      const isDescendantOfMobileFilters = mobileFilters.contains(input);

      /*
        It should be disabled if:
        - it's on mobile and the inputs are not inside the mobile filters
        - it's on desktop and the inputs are inside the mobile filters
      */
      const shouldDisable =
        (isDescendantOfMobileFilters && window.innerWidth >= 768) ||
        (!isDescendantOfMobileFilters && window.innerWidth < 768);

      input.disabled = shouldDisable;
    });
  }

  window.addEventListener('resize', adjustFilterInputsBasedOnViewport);

  adjustFilterInputsBasedOnViewport();

  } catch(e) { console.error(e); }
})();
})();
